import { IconButton } from "@material-ui/core"
import Dialog from "@material-ui/core/Dialog"
import MuiDialogContent from "@material-ui/core/DialogContent"
import { InfoOutlined } from "@material-ui/icons"
import CloseIcon from "@material-ui/icons/Close"
import { Dispatch, SetStateAction, useState } from "react"
import styled from "styled-components"
import { TypographyCenter } from "theme/shared"

const StyledDialog = styled(Dialog)`
  .MuiDialog-paperWidthSm {
    border-radius: 8px;
    overflow: hidden;
    margin: 0 20px;
  }
  .MuiBackdrop-root {
    background: rgba(16, 16, 16, 0.5);
    webkit-backdropfilter: blur(0px);
    backdrop-filter: blur(0px);
  }
`

const StyledContent = styled(MuiDialogContent)`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 0;
`

const StyledCloseButton = styled(IconButton)`
  position: absolute;
  top: 30px;
  right: 30px;
  padding: 0px;
  color: ${(p) => p.theme.colors.black};
  &:hover {
    background-color: transparent;
  }
  ${(p) => p.theme.breakpoints.down("sm")} {
    top: 5.25px;
    right: 15.25px;
    z-index: 10;
  }
`

const StyledScrollable = styled.div`
  width: 100%;
  overflow-y: scroll;
  padding: 30px !important;

  ${(p) => p.theme.breakpoints.down("sm")} {
    padding: 20px !important;
  }
`
const StyledHeaderContainer = styled.div`
  font-family: OENaPro;
  display: flex;
  width: 100%;
  justify-content: center;
  color: ${(p) => p.theme.colors.black};
  font-weight: 300;
  font-size: 16px;
  line-height: 22.4px;
  ${(p) => p.theme.breakpoints.up("md")} {
    font-family: OENaPro;
    font-weight: 400;
    font-size: 24px;
    line-height: 33.6px;
    letter-spacing: 0.8px;
  }
`

const StyledSubHeaderContainer = styled.div`
  font-family: OENaPro;
  font-style: normal;
  font-weight: 300;
  font-size: 12px;
  line-height: 130%;
  margin: 0 10px;

  text-align: center;

  color: #616161;
  margin-top: 15.5px;

  ${(p) => p.theme.breakpoints.up("md")} {
    margin: 0 30px;
    margin-top: 15.5px;

    font-style: normal;
    font-weight: 300;
    font-size: 12px;
    line-height: 130%;

    text-align: center;

    color: #616161;
  }
`

const StyledButton = styled.button`
  display: flex;
  align-items: center;
  color: #999999;
  background-color: transparent;
  border: none;
  font-size: 20px;
`
const StyledDarkSubHeaderContainer = styled.div`
  font-family: OENaPro;
  font-style: normal;
  font-weight: 300;
  font-size: 16px;
  line-height: 130%;
  margin: 0 10px;

  text-align: center;

  color: ${(p) => p.theme.colors.black};

  ${(p) => p.theme.breakpoints.up("md")} {
    margin: 0 30px;

    font-style: normal;
    font-weight: 300;
    font-size: 16px;
    line-height: 130%;

    text-align: center;

    color: ${(p) => p.theme.colors.black};
  }
`

type Props = {
  setOpen: Dispatch<SetStateAction<boolean>>
  open: boolean
  children: JSX.Element
  header?: string
  maxWidth?: false | "xs" | "sm" | "md" | "lg" | "xl"
  width?: number
  customClose?: () => void
  subHeader?: string
  darkSubHeader?: string
}

export default function PopUp({
  setOpen,
  open,
  children,
  header,
  maxWidth,
  width,
  customClose,
  subHeader,
  darkSubHeader,
}: Props) {
  const [isSubHeaderOpen, setIsSubHeaderOpen] = useState(false)
  const handleClose = () => {
    customClose ? customClose() : setOpen(false)
  }

  const handleSubClick = () => {
    setIsSubHeaderOpen(!isSubHeaderOpen)
  }

  return (
    <StyledDialog
      maxWidth={maxWidth}
      onClose={handleClose}
      aria-labelledby="customized-dialog-title"
      open={open}
      style={width ? { width, margin: "auto" } : null}
      aria-modal="true"
      tabIndex={-1}
    >
      <StyledContent>
        {header && (
          <StyledHeaderContainer>
            <TypographyCenter variant="h2" $fontSize="24px" $fontWeight="400">
              {header}
            </TypographyCenter>
            {subHeader && (
              <StyledButton
                onClick={handleSubClick}
                aria-expanded={isSubHeaderOpen ? true : false}
                aria-label="מידע נוסף"
              >
                <InfoOutlined
                  fontSize="inherit"
                  style={{ color: "#616161", fill: "#616161" }}
                />
              </StyledButton>
            )}
          </StyledHeaderContainer>
        )}
        {darkSubHeader && (
          <StyledDarkSubHeaderContainer>
            {darkSubHeader}
          </StyledDarkSubHeaderContainer>
        )}
        {subHeader && isSubHeaderOpen && (
          <StyledSubHeaderContainer>{subHeader}</StyledSubHeaderContainer>
        )}

        <StyledCloseButton onClick={handleClose}>
          <CloseIcon />
        </StyledCloseButton>

        <StyledScrollable>{children}</StyledScrollable>
      </StyledContent>
    </StyledDialog>
  )
}
